import template from './promotion.vhtml';
import VueCookies from 'vue-cookies'

export default {
    template,
    props: {
        campaignTitle : '',
        campaignMessage : '',
        campaignLink: '',
        campaignTarget: '',
        campaignId: ''
    },
    data: () => ({
        showPromotion: false
    }),
    created(){
        if(!VueCookies.isKey(this.campaignId)){
            this.showPromotion = true
        }
    },
    methods: {
        hidePromotion: function () {
            this.showPromotion = false;
            VueCookies.set(this.campaignId)
        }
    }
};


// WEBPACK FOOTER //
// ./assets/_js/components/promotion/promotion.js